import { RoleType } from '@enums';

export class ClientRole {
  id?: number;
  clientsId?: number;
  clientId?: string;
  roleName?: string;
  shortRoleName?: string;
  roleType?: RoleType;

  static MockOne(
    roleName = 'Fullständig',
    shortRoleName = 'Fullständig',
    roleType = RoleType.Fullstandig,
    id = 1,
    clientsId = 123456,
    clientId = 'sxapp.company'
  ) {
    return { id, clientsId, clientId, roleName, shortRoleName, roleType } as ClientRole;
  }
}
